var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('add-button',{on:{"click":() => _vm.$router.push({name: 'RedmineIssueCreatePage'})}}),_c('redmine-issues-list',{attrs:{"status":_vm.$route.params.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }